import { ContractIAImportState, ContractIAImportUnloadState } from '../../states/Contract.IAImport.States';
import { ContractIAImportProcess } from '../../../models/Entities/Contracts/ContractIAImportProcess';
import * as actions from '../../actions/Contract.IAImport.Actions';

// Aplica el proceso calificado sobre lastProcess y sobre el historial. El
// feedback es de única vez, así que lo que devuelve la API es la versión final
// del proceso: se mergea en lugar de reemplazar para no perder campos que el
// endpoint de feedback no repita.
const mergeRatedProcess = (
  state: ContractIAImportState,
  rated: ContractIAImportProcess
): ContractIAImportState => ({
  ...state,
  lastProcess:
    state.lastProcess && state.lastProcess.id === rated.id
      ? { ...state.lastProcess, ...rated }
      : state.lastProcess,
  history: state.history.map(process =>
    process.id === rated.id ? { ...process, ...rated } : process
  ),
});

export default function ContractIAImportRateReducer(
  state: ContractIAImportState | undefined,
  action: any
): ContractIAImportState {
  const currentState = state ?? ContractIAImportUnloadState;
  switch (action.type) {
    case actions.CONTRACT_IAIMPORT_GETRATINGSCALE_REQUEST:
      return {
        ...currentState,
        isGettingRatingScale: true,
        successGettingRatingScale: undefined,
        failOnGettingRatingScale: false,
      };
    case actions.CONTRACT_IAIMPORT_GETRATINGSCALE_SUCCESS:
      return {
        ...currentState,
        isGettingRatingScale: false,
        successGettingRatingScale: true,
        failOnGettingRatingScale: false,
        ratingScale: action.scale ?? [],
      };
    case actions.CONTRACT_IAIMPORT_GETRATINGSCALE_FAILURE:
      return {
        ...currentState,
        isGettingRatingScale: false,
        successGettingRatingScale: false,
        failOnGettingRatingScale: true,
      };

    case actions.CONTRACT_IAIMPORT_RATE_REQUEST:
      return {
        ...currentState,
        isRatingProcess: true,
        successRatingProcess: undefined,
        failOnRatingProcess: false,
        ratingError: undefined,
      };
    case actions.CONTRACT_IAIMPORT_RATE_SUCCESS:
      return {
        ...mergeRatedProcess(currentState, action.process),
        isRatingProcess: false,
        successRatingProcess: true,
        failOnRatingProcess: false,
        ratingError: undefined,
      };
    case actions.CONTRACT_IAIMPORT_RATE_FAILURE: {
      // El 409 trae la calificación vigente: aunque el intento se rechace, esa
      // calificación es el estado real del proceso y se refleja igual.
      const withStandingRating = action.alreadyRatedProcess
        ? mergeRatedProcess(currentState, action.alreadyRatedProcess)
        : currentState;

      return {
        ...withStandingRating,
        isRatingProcess: false,
        successRatingProcess: false,
        failOnRatingProcess: true,
        ratingError: action.error,
      };
    }
    default:
      return currentState;
  }
}
